import { render, staticRenderFns } from "./CenteredQuote.vue?vue&type=template&id=354bd8f6&"
import script from "./CenteredQuote.vue?vue&type=script&lang=js&"
export * from "./CenteredQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports